/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description guarantor info schema
 */

import { defaultSelectProps } from 'components/forms/schema/insuranceSchema';
import stateOptions from 'app-constants/states.json';
import { FIELDS_META } from 'app-constants/accounts/guarantor';
import { PREFERRED_CONTACT_METHODS } from 'app-constants/patients';

// schema keys
const schemaKeys: Record<keyof Guarantor.IFormModel, keyof Guarantor.IFormModel> = {
	guarantorName: 'guarantorName',
	address: 'address',
	city: 'city',
	state: 'state',
	zipCode: 'zipCode',
	cellPhone: 'cellPhone',
	workPhone: 'workPhone',
	email: 'email',
	preferredContactMethod: 'preferredContactMethod',
};

// get guarantor schema
const getGuarantorSchema = (): AnyRecord => {
	return {
		type: 'object',
		properties: {
			formWrapper: {
				type: 'void',
				'x-component': 'div',
				'x-component-props': {
					className: 'py-4 px-6',
				},
				properties: {
					guarantorNameWrapper: {
						type: 'void',
						'x-component': 'FormGrid',
						'x-component-props': {
							minColumns: 1,
							maxColumns: 1,
						},
						properties: {
							[schemaKeys.guarantorName]: {
								type: 'string',
								title: FIELDS_META.guarantorName.title,
								'x-component': 'Input',
								'x-component-props': {
									placeholder: FIELDS_META.guarantorName.placeholder,
									disabled: true,
								},
								'x-validator': [{ required: true, message: FIELDS_META.guarantorName.errorMessage }],
								'x-decorator': 'FormItem',
							},
						},
					},
					otherFieldsWrapper: {
						type: 'void',
						'x-component': 'FormGrid',
						'x-component-props': {
							minColumns: 2,
							maxColumns: 2,
						},
						properties: {
							[schemaKeys.address]: {
								type: 'string',
								title: FIELDS_META.address.title,
								'x-component': 'Input',
								'x-component-props': {
									placeholder: FIELDS_META.address.placeholder,
								},
								'x-decorator': 'FormItem',
							},
							[schemaKeys.city]: {
								type: 'string',
								title: FIELDS_META.city.title,
								'x-component': 'Input',
								'x-component-props': {
									placeholder: FIELDS_META.city.placeholder,
								},
								'x-decorator': 'FormItem',
							},
							[schemaKeys.state]: {
								type: 'string',
								title: FIELDS_META.state.title,
								'x-component': 'Select',
								'x-component-props': {
									...defaultSelectProps,
									options: stateOptions,
									placeholder: FIELDS_META.state.placeholder,
								},
								'x-decorator': 'FormItem',
							},
							[schemaKeys.zipCode]: {
								type: 'string',
								title: FIELDS_META.zipCode.title,
								'x-component': 'Input',
								'x-component-props': {
									placeholder: FIELDS_META.zipCode.placeholder,
								},
								'x-decorator': 'FormItem',
							},
							[schemaKeys.cellPhone]: {
								type: 'string',
								title: FIELDS_META.cellPhone.title,
								'x-component': 'Input',
								'x-component-props': {
									placeholder: FIELDS_META.cellPhone.placeholder,
								},
								'x-decorator': 'FormItem',
							},
							[schemaKeys.workPhone]: {
								type: 'string',
								title: FIELDS_META.workPhone.title,
								'x-component': 'Input',
								'x-component-props': {
									placeholder: FIELDS_META.workPhone.placeholder,
								},
								'x-decorator': 'FormItem',
							},
							[schemaKeys.email]: {
								type: 'string',
								title: FIELDS_META.email.title,
								'x-component': 'Input',
								'x-component-props': {
									placeholder: FIELDS_META.email.placeholder,
								},
								'x-decorator': 'FormItem',
							},
							[schemaKeys.preferredContactMethod]: {
								type: 'string',
								title: FIELDS_META.preferredContactMethod.title,
								'x-component': 'Select',
								'x-component-props': {
									...defaultSelectProps,
									options: PREFERRED_CONTACT_METHODS,
									placeholder: FIELDS_META.preferredContactMethod.placeholder,
								},
								'x-decorator': 'FormItem',
							},
						},
					},
				},
			},
		},
	};
};

export { schemaKeys };
export default getGuarantorSchema;
